import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AmountVisibilityService } from '../../services/ui/amount-visibility.service';

/**
 * The toolbar's switch for the money on the list pages.
 *
 * In the header rather than on a page because it is about the screen — who else can see
 * it — and not about any one page: set at the counter, it holds from the registry to the
 * receipts to the takings.
 */
@Component({
  selector: 'app-amount-toggle',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, MatTooltipModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <button
      mat-icon-button
      data-testid="amount-toggle"
      [matTooltip]="label()"
      [attr.aria-label]="label()"
      [attr.aria-pressed]="amounts.hidden()"
      (click)="amounts.toggle()"
    >
      <mat-icon>{{ amounts.hidden() ? 'visibility_off' : 'visibility' }}</mat-icon>
    </button>
  `,
})
export class AmountToggleComponent {
  protected readonly amounts = inject(AmountVisibilityService);

  /** What a click does, not what the state is: the icon already says the state. */
  protected label(): string {
    return this.amounts.hidden() ? 'Mostra gli importi' : 'Nascondi gli importi';
  }
}
